import { render, staticRenderFns } from "./AdminCache.vue?vue&type=template&id=74fbb1cc&"
import script from "./AdminCache.vue?vue&type=script&lang=js&"
export * from "./AdminCache.vue?vue&type=script&lang=js&"
import style0 from "./AdminCache.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports